export enum CompanyStatus {
  ACTIVA = 'ACTIVA',
  EN_RENOVACION = 'EN RENOVACION',
  NO_RENOVADA = 'NO RENOVADA',
  SUSPENDIDA = 'SUSPENDIDA',
  CANCELADA = 'CANCELADA',
  NO_ASIGNADA = 'NO ASIGNADA',
}
